export const UNLOCKED_CAR_SALES_LS_KEY: string = 'carSalesUnlocked';
export const USE_REWARDS_KEY: string = 'cars_useRewards';
